import { Magic } from "magic-sdk";
import { REACT_APP_CHAIN_ID, REACT_APP_RPC_URL, REACT_APP_MAGIC_KEY } from "../../config";

export const magic = new Magic(REACT_APP_MAGIC_KEY as string, {
  network: {
    rpcUrl: REACT_APP_RPC_URL,
    chainId: parseInt(REACT_APP_CHAIN_ID),
  },
});
